(function(){

  'use strict'

  angular
    .module('app')
    .factory('CongressiFactory', CongressiFactory)
    .factory('RivisteFactory', RivisteFactory)
    .factory('PublicazioniScientificheFactory', PublicazioniScientificheFactory)
  ;

  ////////////////////////////

  function CongressiFactory(){

    var c =  [
      {
        anno: 2014,
        testo: [
          [
            'In Maggio ha cominciato i corsi di perfezionamento ai colleghi ortodonzisti sui retainers attivi',
            'Relatore presso il Congresso ESLO | Cernobbio sul lago di Como',
            'Titolo relazione | The allignment by ADA wire'
          ]
        ]
      },
      {
        anno: 2013,
        testo: [
          [
            'Relatore presso il Congresso WSLO | Parigi | Luglio',
            'Titolo relazione | The advanced active retainer (R2A) and the new ADA wire'
          ]
        ]
      },
      {
        anno: 2012,
        testo: [
          [
            'Relatore presso il Congresso ESLO | Francoforte | 28 Giugno - 1 Luglio',
            'Titolo relazione | Advanced Active Retainer (R2A): Seven years of experience',
            'Autori | A. D\'Alessandro, R. De Santis'
          ]
        ]
      },
      {
        anno: 2011,
        testo: [
          [
            'Relatore presso il XXIII SIDO International Congress | Roma | 10 - 12 Novembre',
            'Titolo relazione | Il Retainer Attivo Avanzato (R2A): sei anni di esperienza',
            'Nuove prospettive nel trattamento ortodontico chirurgico: prima la chirurgia, prima la mandibola'
          ]
        ]
      },
      {
        anno: 2010,
        testo: [
          [
            'Relatore presso il Congresso ESLO | Londra | 8 - 11 Luglio',
            'Titolo relazione | Advanced Active Retainer - Fixed lingual orthodontics without brackets',
          ],
          [
            'Relatore al XXII Congresso Internazionale SIDO | Firenze | 24 - 27 Novembre',
            'Titolo delle relazioni | Il trattamento invisibile fisso senza attacchi: il Retainer Attivo Avanzato',
            'Terapia ortodontica invisibile senza brackets nelle discrepanze scheletriche'
          ]
        ]
      },
      {
        anno: 2009,
        testo: [
          [
            'Relatore presso il Congresso Mondiale WSLO | Buenos Aires | 4 - 7 Marzo',
            'Titolo relazione | Advanced Active Retainer - Fixed lingual orthodontics with no brackets'
          ]
        ]
      },
      {
        anno: 2008,
        testo: [
          [
            'Autore della pubblicazione scientifica su Doctor Os | Anno XIX, September 2008; 749-753',
            'Titolo pubblicazione | Il trattamento ortodontico linguale senza attacchi nel paziente adulto',
          ],
          [
            'Relatore presso il Congresso ESLO | Cannes | 3 - 6 Luglio',
            'Titolo della relazione | Lingual orthodontic treatment without brackets in adult patients',
          ],
          [
            'Relatore presso il XIX Congresso Internazionale SIDO | Firenze | 20 Novembre',
            'Titolo della relazione | Il trattamento ortodontico linguale senza attacchi nel paziente adulto'
          ]
        ]
      },
      {
        anno: 2007,
        testo: [
          [
            'Relatore presso il Congresso internazionale SIDO | Napoli | 24-27 Ottobre',
            'Titolo della relazione | Lingual orthodontic treatment without brackets in adult patients'
          ]
        ]
      }
    ];


    return c;
  }

  ////////////////////////////

  function RivisteFactory(){
    var r = [
      {
        title: 'estetic_2',
        num_photos : 3,
        path : 'img/dicono-di-noi/estetic_2/',
        width: 217.5,
        height: 294
      },
      {
        title: 'estetic',
        num_photos : 5,
        path : 'img/dicono-di-noi/estetic/',
        width: 217.5,
        height: 294
      },
      {
        title: 'silhouette',
        num_photos : 3,
        path : 'img/dicono-di-noi/silhouette/',
        width: 217.5,
        height: 294
      },
      {
        title: 'starbene',
        num_photos : 3,
        path : 'img/dicono-di-noi/starbene/',
        width: 217.5,
        height: 294
      },
      {
        title: 'starbene_2',
        num_photos : 5,
        path : 'img/dicono-di-noi/starbene_2/',
        width: 217.5,
        height: 294
      }
    ];

    r.default = {
      width: 217.5,
      height: 294,
    };

    return r;
  }

  ////////////////////////////

  function PublicazioniScientificheFactory(){
    var r = [
      {
        title: 'doctoros',
        num_photos : 3,
        path : 'img/dicono-di-noi/doctoros/',
        width: 217.5,
        height: 294
      }
    ];

    r.default = {
      width: 217.5,
      height: 294,
    };

    return r;
  }

  ////////////////////////////

})();
